import { useLocalStorage } from "@uidotdev/usehooks";
import { ChevronRight } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

export function Select({ id, label, idx = 1 }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [unidade, setUnidade] = useLocalStorage("sessionUnidade", null);
  const [, setUnidadeNome] = useLocalStorage("sessionUnidadeNome", null);

  function handleClick() {
    let targetRoute = "";

    if (location.pathname === "/setor" && id === "comercial") {
      window.open(
        "https://wa.me/557199885711?text=Ol%C3%A1%2C%20gostaria%20de%20iniciar%20meu%20atendimento%21",
        "_blank",
      );
    } else if (location.pathname === "/unidade") {
      targetRoute = "/setor";
      setUnidade(id);
      setUnidadeNome(label);
    } else if (location.pathname === "/setor") {
      targetRoute = `/setor/${id}`;
    } else if (location.pathname.includes("/setor/secretaria")) {
      targetRoute = `/setor/secretaria/${id}`;
    } else if (location.pathname.includes("/setor/financeiro")) {
      targetRoute = `/setor/financeiro/${id}`;
    } else if (location.pathname.includes("/setor/pedagogico")) {
      targetRoute = `/setor/pedagogico/${id}`;
    } else if (id === "recuperar_senha") {
      targetRoute = `/setor/recuperar_senha`;
    }

    if (targetRoute) {
      navigate(targetRoute);
    }
  }

  return (
    <div
      onClick={handleClick}
      className="flex flex-row justify-between items-center bg-white border border-border px-4 py-2 rounded-md cursor-pointer hover:bg-[#ed3237]/90 hover:text-white"
    >
      <div className="flex items-center justify-center border border-border px-3 py-1 rounded-md">
        <p className="font-bold select-none">{idx}</p>
      </div>
      <div>
        <p className="text-1xl font-semibold select-none">{label}</p>
      </div>
      <ChevronRight className="size-6" />
    </div>
  );
}
